<template>
  <div class="d-flex" style="gap: 1rem">
    <button
      v-for="status in availableStatuses"
      :key="status.value"
      class="btn btn-sm text-white"
      :style="`background-color: ${status.color};`"
      @click.stop="changeStatus(status.value)"
    >
      {{ status.btnText }}
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    currentStatus: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      prospectStatus: "getProspectStatus",
    }),

    availableStatuses() {
      return this.prospectStatus.filter((s) => s.value !== this.currentStatus);
    },
  },

  methods: {
    changeStatus(status) {
      this.$emit("change", status);
    },
  },
};
</script>
